export function unvisibleButton(action) {
    return ['PrintButton','PrintButtonV2','PopImportForm','PopExportButton','ExportButton','PopAttachDownloadForm','RewardButton'].indexOf(action) > -1;
}



// WEBPACK FOOTER //
// ./src/components/util/unvisibleButton.js